(ns practitest.frontend.components2.modal-header)

(defn modal-header
  "Modal title area: icon box, bold title with an optional \" | context\", a subtitle below,
   and an optional `aside` element on the right (e.g. a selection summary)."
  [{:keys [icon title context subtitle aside]}]
  [:div.modal-header-content
   [:div.modal-header-main
    (when icon
      [:span.modal-header-icon icon])
    [:div
     [:div.modal-header-title
      title
      (when context
        [:span.modal-header-context " | " context])]
     (when subtitle
       [:span.modal-header-subtitle subtitle])]]
   aside])
